module.exports = __webpack_public_path__ + "img/DE05891.adb1ccfa.png";